// Core Components
//工具栏
import Toolbar from '../components/core/Toolbar.vue';
//页底
import PageFooter from '../components/core/PageFooter.vue';
//地图
import Commap from '../components/map/Commap.vue';
//面包屑
import Breadcrumbs from '../components/core/Breadcrumbs.vue';
//文本框
import Editor from '../components/core/Editor.vue';
//导航栏
import Navigation from '../components/core/NavigationDrawer.vue';
//提示框
import Confirm from '../components/confirm/Confirm.vue';
// //新闻编辑
// import Newedit from '../views/backStage/NewContentByAuthor.vue';


function setupComponents(Vue) {

  Vue.component('toolbar', Toolbar);
  Vue.component('page-footer', PageFooter);
  Vue.component('com-map', Commap);
  Vue.component('breadcrumbs', Breadcrumbs);
  Vue.component('editor', Editor);
  Vue.component('navigation', Navigation);
  Vue.component('confirm', Confirm);
  // Vue.component('newsedit', Newedit);
}


export {
  setupComponents
}